import styled from 'styled-components';

export const SideNav = styled.div`
  @media print {
    border-right: 0;
  }

  &.page-subnav {
    box-sizing: border-box;
    width: 250px;
    height: calc(100vh - 60px);
    border-right: 1px solid #e0e4e8;
    background-color: #ffffff;
    z-index: 1;
    position: fixed;
    padding: 0;
    @media print {
      display: none;
    }
  }

  .actionbar {
    margin-top: 4px;
    padding: 10px;

    li {
      list-style-type: none;
    }
  }

  .footer {
    position: absolute;
    bottom: 20px;
    width: 100%;
    padding: 0 20px;
  }
`;

export const ReportsPageSection = styled.div`
  min-width: 800px;
  width: 100%;
`;

export const SidebarIcon = styled.span`
  margin-right: 10px;
  margin-top: 10px;
`;
